module.exports = __webpack_public_path__ + "img/world-map.4d7b11c7.png";